
import axios from "axios";

//  You can use an environment variable for base URL
const API_URL = process.env.REACT_APP_API_URL ;

const client = axios.create({
  baseURL: API_URL,
});

// function to get businesses
export const gettopBusinesses = async (secret_key) => {
  try {
    const response = await client.get("/api/bussiness", {
      params: { secret_key },
    });
    return response.data.data ?? [];
  } catch (error) {
    console.error("API Error:", error);
    throw error; // so component can handle it
  }
};


// function to search  businesses
export const getsearchBusinesses = async (secret_key,bussiness,state,country,category) => {
  try {
    const response = await client.get("/api/bussiness", {
      params: {secret_key,bussiness,state,country,category},
    });
    return response.data.data ?? [];
  } catch (error) {
    console.error("API Error:", error);
    throw error; 
  }
};

// Example function to get bussiness category
export const getbussinesscategory = async (secret_key) => {
  try {
    const response = await client.get("/api/bussinesscategory", {
      params: { secret_key },
    });
    return response.data.data ?? [];
  } catch (error) {
    console.error("API Error:", error);
    throw error; 
  }
};

// clientapi.js
export const getBusinessDetail = async (secret_key, id) => {
  try {
    const response = await client.get("/api/bussiness/show", {
      params: {
        secret_key,
        id,
      },
    });
    return response.data.data ?? {};
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};


export default client;
